import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true, fill: true },
  },
});

type ProfileInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ProfileInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: ProfileInactiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M14.501 25.584c6.121 0 11.084-4.962 11.084-11.084 0-6.12-4.963-11.083-11.084-11.083-6.12 0-11.083 4.962-11.083 11.083 0 6.122 4.962 11.084 11.083 11.084zM7.938 23.429a7.388 7.388 0 0113.127 0"
        className={pathClassName.replace("fill", "stroke")}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.5 15.732a3.965 3.965 0 100-7.931 3.965 3.965 0 000 7.93z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default ProfileInactiveIcon;
